var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGhost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5297 15.9446C10.0865 16.0185 8.43425 16.0185 7.87275 15.9446C3.49281 15.3684 0 12.166 0 7.8375C0 3.50897 3.58172 0 8 0C12.4183 0 16 3.50897 16 7.8375C16 9.85066 15.2252 11.6865 13.9519 13.0746C13.6061 13.4515 14.0805 13.7159 14.5626 13.9845C15.0353 14.248 15.5154 14.5155 15.2364 14.8973C14.9289 15.3179 13.2622 15.8559 11.5297 15.9446ZM6.875 6.85781C6.875 7.53412 6.31534 8.08241 5.625 8.08241C4.93466 8.08241 4.375 7.53412 4.375 6.85781C4.375 6.40422 4.62672 6.00825 5.00075 5.79659C5.02228 6.38631 5.50716 6.85778 6.10216 6.85778H6.875V6.85781ZM10.7493 5.79659C10.7277 6.38631 10.2428 6.85778 9.64784 6.85778H8.875V6.85781C8.875 7.53412 9.43466 8.08241 10.125 8.08241C10.8153 8.08241 11.375 7.53412 11.375 6.85781C11.375 6.40422 11.1233 6.00825 10.7493 5.79659Z",
    fill: "#616EB7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.ced74fa20556a3d22bb7d6a1497e2325.svg";
export { ForwardRef as ReactComponent };